export class MaplibreToggleEvent {
    #type;
    constructor(type) {
        this.#type = type;
    }
    get type() {
        return this.#type;
    }
    preventDefault() { }
    static convert(callback) {
        return (e) => callback(new MaplibreToggleEvent(e.type));
    }
    static isType(eventType) {
        return eventType === 'open' || eventType === 'close';
    }
    static convertType(eventType) {
        return eventType;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9nZ2xlLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbImV2ZW50cy90b2dnbGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxPQUFPLG1CQUFtQjtJQUMvQixLQUFLLENBQWtCO0lBRXZCLFlBQVksSUFBc0I7UUFDakMsSUFBSSxDQUFDLEtBQUssR0FBRyxJQUFJLENBQUE7SUFDbEIsQ0FBQztJQUVELElBQUksSUFBSTtRQUNQLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQTtJQUNsQixDQUFDO0lBRUQsY0FBYyxLQUFVLENBQUM7SUFFekIsTUFBTSxDQUFDLE9BQU8sQ0FDYixRQUEwQztRQUUxQyxPQUFPLENBQUMsQ0FBNkIsRUFBRSxFQUFFLENBQ3hDLFFBQVEsQ0FBQyxJQUFJLG1CQUFtQixDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFBO0lBQzNDLENBQUM7SUFFRCxNQUFNLENBQUMsTUFBTSxDQUFDLFNBQWlCO1FBQzlCLE9BQU8sU0FBUyxLQUFLLE1BQU0sSUFBSSxTQUFTLEtBQUssT0FBTyxDQUFBO0lBQ3JELENBQUM7SUFFRCxNQUFNLENBQUMsV0FBVyxDQUFDLFNBQXNDO1FBQ3hELE9BQU8sU0FBUyxDQUFBO0lBQ2pCLENBQUM7Q0FDRCJ9